import { useQuery } from "react-query"
import { useOffersModules } from "@tm/context-distribution"
import { Advertisement } from "@tm/models"
import { getAdvertisement } from "./getAdvertisement"
import { GetAdvertisementRequest } from "./model"

const EMPTY_ARRAY: Advertisement[] = []

export function useAdvertisement(advertisementId?: string) {
    const { hasOfferCarouselModuleEnabled } = useOffersModules()

    const { data, isLoading, isSuccess, isError } = useQuery(
        ["offers_advertisement-items", advertisementId],
        () => getAdvertisement({ advertisementId } as GetAdvertisementRequest),
        {
            enabled: hasOfferCarouselModuleEnabled && !!advertisementId,
            refetchOnMount: true,
            staleTime: 1000 * 60 * 60, // keep data for 1 hour
        }
    )
    return {
        advertisementItems: data?.advertisements ?? EMPTY_ARRAY,
        advertisementItemsLoading: isLoading,
        advertisementItemsLoaded: !isLoading && (isSuccess || isError),
    }
}
